module.exports = __webpack_public_path__ + "0a597f020984085fa0176fd6e435080e.pdf";